<div class="inner-content" >
    <div class="wrapper" *transloco="let t; read: 'chooseGroupModal'">
        <div class="title" *ngIf="type==='telegram'">
            {{ t('telegramTitle') }}
        </div>

        <div class="title" *ngIf="type ==='practicing'">
            {{ this.groups?.length ? t('workTitle') : t('workTitleNoGroups') }}
        </div>


        <div class="title" *ngIf="type ==='studentsMeeting'">

            {{ this.groups?.length ? t('studentsMeeting') : t('studentsMeetingNoGroups') }}
        </div>


        <div class="title" *ngIf="type==='meeting'">
            {{ t('meeting') }}
        </div>

        <div class="item" *ngFor="let group of this.groups">
            <div class="info">
<!--                <div class="name"> {{ t('group') }}</div>-->

                <div class="title">
<!--                    {{ group.title|transloco }}-->
                    {{ group.title }}
                </div>
            </div>

            <div class="btn-wrapper">

<!--                <button *ngIf="type==='telegram'" type="button" class="btn green-btn"-->
<!--                        (click)="openUrl( group.telegramUrl)"> {{ t('telegramBtn') }}-->
<!--                </button>-->

                <div class="btn-wrapper-practicing" [ngClass]="{'no-available':  !group.telegramUrl}">
                    <button *ngIf="type==='telegram'" type="button" class="btn green-btn"
                            [ngClass]="{'no-cursor':  !group?.telegramUrl}"
                            (click)="openUrl( group?.telegramUrl)"> {{ t('telegramBtn') }}
                    </button>

                    <div class="info-popover d-none ">
                      {{t('notAvailableTelegram') }}

                    </div>
                </div>



<!--                <button *ngIf="type==='studentsMeeting' && group?.studentsMeetingUrl!=undefined" type="button" class="btn green-btn"-->
<!--                        (click)="openUrl( group.studentsMeetingUrl)"> {{ t('telegramBtn') }}-->
<!--                </button>-->

                <div class="btn-wrapper-practicing" [ngClass]="{'no-available':  !group.studentsMeetingUrl}">
                    <button *ngIf="type==='studentsMeeting'" type="button" class="btn green-btn"
                            [ngClass]="{'no-cursor':  !group?.studentsMeetingUrl}"
                            (click)="openUrl( group?.studentsMeetingUrl)"> {{ t('telegramBtn') }}
                    </button>

                    <div class="info-popover d-none ">
                      {{t('noAvailableStudentsMeeting') }}

                    </div>
                </div>


                <div class="btn-wrapper-practicing" [ngClass]="{'no-available':  !group.practicingUrl}">
                    <button *ngIf="type==='practicing'" type="button" class="btn green-btn"
                            [ngClass]="{'no-cursor':  !group.practicingUrl}"
                            (click)="openUrl( group.practicingUrl)"> {{ t('workBtn') }}
                    </button>

                    <div class="info-popover d-none ">
                         {{t('notAvailablePracticing') }}

                    </div>
                </div>

<!--                <button *ngIf="type==='meeting' && group.parentMeetingUrlZNO" type="button" class="btn green-btn"-->
<!--                        (click)="openUrl( group.parentMeetingUrlZNO)"> {{ t('telegramBtn') }}-->
<!--                </button>-->

                <div class="btn-wrapper-practicing" [ngClass]="{'no-available':  ! group.parentMeetingUrlZNO}">
                    <button *ngIf="type==='meeting' && group.parentMeetingUrlZNO" type="button" class="btn green-btn"
                            [ngClass]="{'no-cursor':  !group?.parentMeetingUrlZNO}"
                            (click)="openUrl( group?.parentMeetingUrlZNO)"> {{ t('telegramBtn') }}
                    </button>

                    <div class="info-popover d-none ">
                        {{t('notAvailableMeeting') }}

                    </div>
                </div>

<!--                <button *ngIf="type==='meeting' && !group.parentMeetingUrlZNO" type="button" class="btn green-btn"-->
<!--                        (click)="openUrl( group.parentMeetingUrl)"> {{ t('telegramBtn') }}-->
<!--                </button>-->

                <div class="btn-wrapper-practicing" [ngClass]="{'no-available':  ! group.parentMeetingUrlZNO}">
                    <button *ngIf="type==='meeting' && !group.parentMeetingUrlZNO" type="button" class="btn green-btn"
                            [ngClass]="{'no-cursor':  !group?.parentMeetingUrl}"
                            (click)="openUrl( group?.parentMeetingUrl)"> {{ t('telegramBtn') }}
                    </button>

                    <div class="info-popover d-none " *ngIf="!group.parentMeetingUrl">
                        {{t('notAvailableMeeting') }}

                    </div>
                </div>

            </div>


        </div>

        <div class="close" (click)="close()">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.26035 8.26035C8.60748 7.91322 9.1703 7.91322 9.51743 8.26035L16 14.743L22.4826 8.26041C22.8297 7.91327 23.3925 7.91327 23.7396 8.26041C24.0868 8.60754 24.0868 9.17035 23.7397 9.51749L17.2571 16L23.7396 22.4825C24.0867 22.8296 24.0867 23.3925 23.7396 23.7396C23.3925 24.0867 22.8296 24.0867 22.4825 23.7396L16 17.2571L9.51749 23.7397C9.17036 24.0868 8.60754 24.0868 8.26041 23.7397C7.91328 23.3925 7.91328 22.8297 8.26041 22.4826L14.7429 16L8.26035 9.51743C7.91322 9.1703 7.91322 8.60748 8.26035 8.26035Z"
                      fill="#83B25F"/>
            </svg>
        </div>


    </div>
</div>
